export default {"src":"/_next/static/media/noise.666c6be9.svg","height":29,"width":30,"blurWidth":0,"blurHeight":0};